import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const GoogleIcon = () => (
  <svg viewBox="0 0 48 48" className="w-5 h-5" aria-hidden="true"><path fill="#FFC107" d="M43.6 20.1H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.6-.4-3.9z"/><path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.1H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.6-.4-3.9z"/></svg>
);
const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5" aria-hidden="true"><path fill="#1877F2" d="M24 12a12 12 0 1 0-13.9 11.9v-8.4H7.1V12h3V9.4c0-3 1.8-4.7 4.5-4.7 1.3 0 2.7.2 2.7.2v3h-1.5c-1.5 0-2 .9-2 1.9V12h3.4l-.5 3.5h-2.9v8.4A12 12 0 0 0 24 12z"/></svg>
);
const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5" aria-hidden="true"><defs><linearGradient id="ig" x1="0" y1="1" x2="1" y2="0"><stop offset="0" stopColor="#FEDA75"/><stop offset=".35" stopColor="#FA7E1E"/><stop offset=".6" stopColor="#D62976"/><stop offset="1" stopColor="#4F5BD5"/></linearGradient></defs><rect x="2" y="2" width="20" height="20" rx="6" fill="url(#ig)"/><circle cx="12" cy="12" r="4.2" fill="none" stroke="#fff" strokeWidth="1.8"/><circle cx="17.3" cy="6.7" r="1.2" fill="#fff"/></svg>
);

const PROVIDERS = [["google", "Google", GoogleIcon], ["facebook", "Facebook", FacebookIcon], ["instagram", "Instagram", InstagramIcon]];

export const SocialLogin = ({ label = "Accedi" }) => {
  const [cfg, setCfg] = useState({ google: true });
  useEffect(() => { api.get("/auth/social/config").then((r) => setCfg(r.data)).catch(() => {}); }, []);
  const go = (p, name) => {
    const back = `${window.location.origin}/accesso-social`;
    if (p === "google") { window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(back)}`; return; }
    if (!cfg[p]) { toast.info(`L'accesso con ${name} è in fase di attivazione: per ora usa Google o email e password`); return; }
    window.location.href = `${BACKEND}/api/auth/${p}/start?origin=${encodeURIComponent(window.location.origin)}`;
  };
  return (
    <div data-testid="social-login">
      <div className="grid gap-2">
        {PROVIDERS.map(([p, name, Icon]) => (
          <button key={p} type="button" onClick={() => go(p, name)} data-testid={`social-${p}`}
            className="w-full inline-flex items-center justify-center gap-3 border border-slate-300 bg-white rounded-full px-4 py-2.5 text-sm font-semibold text-[#0D2B5A] hover:border-[#C98A3C] hover:bg-[#FBF6EE] transition-colors duration-200">
            <Icon/>{label} con {name}
          </button>
        ))}
      </div>
      <p className="text-[11px] text-slate-400 mt-2 text-center">Instagram: solo account professionali (Business o Creator).</p>
      <div className="flex items-center gap-3 my-5 text-xs text-slate-400"><span className="flex-1 h-px bg-slate-200"/>oppure con email<span className="flex-1 h-px bg-slate-200"/></div>
    </div>
  );
};

export function useSocialPending() {
  const [params] = useSearchParams();
  const id = params.get("social");
  const [pending, setPending] = useState(null);
  useEffect(() => {
    if (!id) { return; }
    api.get(`/auth/social/pending/${id}`).then((r) => setPending(r.data)).catch((e) => toast.error(e?.response?.data?.detail || "Sessione social scaduta"));
  }, [id]);
  return pending;
}

const PNAME = { google: "Google", facebook: "Facebook", instagram: "Instagram" };
export const SocialPendingBanner = ({ pending }) => (pending ? (
  <div className="mb-6 rounded-2xl border border-gold/50 bg-[#FBF6EE] px-4 py-3 text-sm text-[#0D2B5A]" data-testid="social-pending-banner">
    Stai completando l'iscrizione con <b>{PNAME[pending.provider]}</b>{pending.name ? ` come ${pending.name}` : ""}. Scegli il tipo di account e completa i dati obbligatori: non serve una password.
  </div>
) : null);
